import React from 'react';
import { faTimes } from '@fortawesome/pro-solid-svg-icons/faTimes';
import classnames from 'clsx';

import { IconButton } from 'ui-components/components/button/icon-button';

import { useProductDetailsContext } from '../../../use-product-details-context';
import { messages } from '../../../messages';
import style from './product-details-drawer-header.module.less';

type ProductDetailsDrawerHeaderProps = {
  className?: string;
};

export const ProductDetailsDrawerHeader = ({ className = '' }: ProductDetailsDrawerHeaderProps) => {
  const { headerText, closeModal } = useProductDetailsContext();

  return (
    <div className={classnames(style['header-wrapper'], className)}>
      <div className={style.title}>{headerText}</div>
      <div className={style['close-wrapper']}>
        <IconButton ariaLabelMessageDescriptor={messages.drawerCloseAriaLabel} icon={faTimes} onClick={closeModal} />
      </div>
    </div>
  );
};
